
import Vue from "vue";
import TableCustom from "@/components/TableCustom.vue";
import colorStatus from "@/common/mixins/colorStatus";
import DragHandleIcon from "@/components/icons/DragHandleIcon.vue";

const STORAGE_KEY = "overall.mcaStatusByEquipment.collapsed";

export default Vue.extend({
  name: "McStatusByEquipment",
  mixins: [colorStatus],
  components: { TableCustom, DragHandleIcon },
  computed: {
    filteredDatas() {
      if (this.selectedStatus === null) return this.datas;
      return this.datas.filter((row) => row.overAll === this.selectedStatus);
    },
    companyId(): any {
      return this.$store.getters.company.id || 0;
    },
  },
  data() {
    let datas = [];
    let overallStatus = -1;
    let headerTable = [
      { text: "Over All", value: "overAll", sortable: false, hideLabel: true },
      { text: "Equipment Name", value: "equipmentName", sortable: false, padding: 0 },
      { text: "Airgap", value: "airGrap", sortable: false, textAlign: "center" },
      { text: "Ground Fault", value: "groundFault", sortable: false, textAlign: "center" },
      { text: "Mechanical Failure", value: "mechanicalFailure", sortable: false, textAlign: "center" },
      { text: "Power Quality", value: "powerQuality", sortable: false, textAlign: "center" },
      { text: "Rotor", value: "rotor", sortable: false, textAlign: "center" },
      { text: "Stator", value: "stator", sortable: false, textAlign: "center" },
      { text: "Terminal Box", value: "terminalBox", sortable: false, textAlign: "center" },
      { text: "To", value: "to", sortable: false, hideLabel: true, width: "24px" },
    ];
    let statusList = [
      { name: "All", value: null, count: 0 },
      { name: "Normal", value: 0, count: 0 },
      { name: "Warning", value: 1, count: 0 },
      { name: "Alarm", value: 2, count: 0 },
      { name: "Offline", value: -1, count: 0 },
      { name: "Disabled", value: -2, count: 0 },
    ];

    return {
      datas,
      overallStatus,
      headerTable,
      selectedStatus: null,
      statusList,
      isLoading: false,
      isCollapsed: true,
    };
  },
  async created() {
    try {
      this.isCollapsed = window.localStorage.getItem(STORAGE_KEY) !== "open";
    } catch {
      this.isCollapsed = true;
    }
    this.fetchOverallModel();
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    async fetchOverallModel() {
      this.isLoading = true;
      if (!this.companyId) return;

      try {
        let maxOverall = [];
        this.statusList.forEach((status) => (status.count = 0));

        this.datas = await Vue.prototype.$dep.modelUseCase.getOverallStatusMca(this.companyId);

        this.datas = this.datas
          .sort((a, b) => {
            // First: sort by overAllStatus descending
            if (b.overAllStatus !== a.overAllStatus) {
              return b.overAllStatus - a.overAllStatus;
            }
            // Second: sort by equipment_name alphabetically
            return a.equipment_name.localeCompare(b.equipment_name);
          })
          .map((val) => {
            let tempData = {
              overAll: val.overAllStatus,
              airGrap: val.airgapStatus,
              bearing: val.bearingStatus,
              groundFault: val.groundFaultStatus,
              mechanicalFailure: val.mechanicalFailureStatus,
              powerQuality: val.powerQualityStatus,
              rotor: val.rotorStatus,
              stator: val.statorStatus,
              terminalBox: val.terminalBoxStatus,
              equipmentName: val.equipment_name,
              modelId: val.model_id,
            };
            maxOverall.push(val.overAllStatus);

            this.statusList.forEach((status) => {
              if (status.value === val.overAllStatus || status.value === null) {
                status.count++;
              }
            });

            return tempData;
          });
        this.overallStatus = Math.max(...maxOverall);
      } catch (error) {
        console.error("Error fetching VCA overall status:", error);
      } finally {
        this.isLoading = false;
      }
    },
    status(status: number) {
      const map: Record<
        number,
        {
          label: string;
          color: string;
          code: string;
          bgColor: string;
        }
      > = {
        0: { label: "Normal", color: "normal", code: "#4caf50", bgColor: "bg-[#2EC577]/[0.2]" },
        1: { label: "Warning", color: "warning", code: "#ffc12b", bgColor: "bg-[#FCA239]/[0.2]" },
        2: { label: "Alarm", color: "alarm", code: "#f44336", bgColor: "bg-[#D9263B]/[0.2]" },
        [-1]: { label: "Offline", color: "offline", code: "#a5acb2", bgColor: "bg-[#A5ACB3]/[0.2]" },
        [-2]: { label: "Disabled", color: "disabled", code: "#808080", bgColor: "bg-[#808080]/[0.2]" },
      };
      return map[status] || { label: "Disabled", color: "disabled", code: "#808080" };
    },
    handleOpenMenu(id: any) {
      this.$router.push({ name: "ViewModelPage", params: { id } });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  watch: {
    companyId() {
      this.fetchOverallModel();
    },
    isCollapsed(value: boolean) {
      try {
        window.localStorage.setItem(STORAGE_KEY, value ? "closed" : "open");
      } catch {
        /* localStorage unavailable -- ignore */
      }
    },
  },
});
